import React, { useMemo } from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import useWorkbook from 'components/ScalarSpreadsheet/utilities/useWorkbook';
import { CashFlowSummaryProps } from './CashFlowSummary.props';
import { useCashFlowSummarySpreadsheetConfig } from './hooks/useCashFlowSummarySpreadsheetConfig';

const CashFlowSummary: React.FC<CashFlowSummaryProps> = props => {
  const { spreadsheet, hasData } = useCashFlowSummarySpreadsheetConfig(props);

  const spreadsheets = useMemo(() => (spreadsheet ? [spreadsheet] : []), [spreadsheet]);
  const { cells, workbook, data } = useWorkbook(spreadsheets);

  if (!hasData || !spreadsheet) {
    return null;
  }

  return (
    <Box sx={{ mt: 2 }} data-testid="cash-flow-summary">
      <Typography variant="h6" sx={{ mb: 1, pl: '12px', color: 'primary.main' }}>
        Cash Flow Summary
      </Typography>
      {cells && data && (
        <ScalarSpreadsheet
          {...spreadsheet}
          cells={cells}
          showTitlesColumn={false}
          showToolbar={false}
          workbook={workbook}
          sheet={spreadsheet}
          data={data}
        />
      )}
    </Box>
  );
};

export default CashFlowSummary;
